import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import "./TournamentTimer.style.scss";


const TournamentTimer = ({targetDate, timeOutLabel, finish: propFinish, cultureLg}) => {
    const [timeLeft, setTimeLeft] = useState(null);
    const [isOneHourLeft, setIsOneHourLeft] = useState(false);
    const theTimer = useRef(null);
    const [timerStarted, setTimerStarted] = useState(false);

    useEffect(() => {
        if(!targetDate || targetDate?.getTime() === 0){
            setTimeLeft("n/a");
        }else{
            startTimer();
        }

        // onComponentUnMount
        return () => {
            clearInterval(theTimer.current);
        }
    }, [])

    const startTimer = () => {

        if(timerStarted)
            return;

        clearInterval(theTimer.current);

        let minutes, seconds, hours, days = null;

        setTimerStarted(true);

        let dayLetter = 'd';


        theTimer.current = setInterval(()=> {
            dayLetter = cultureLg === 'fr' ? 'j' : 'd';

            const totalSec = (targetDate.getTime() - new Date().getTime())/1000;
            const totalMin = Math.floor(totalSec / 60);
            const totalHour = Math.floor(totalMin / 60);
            const totalDays = Math.floor(totalHour / 24);

            days = totalDays;
            hours = totalHour - (totalDays * 24);
            minutes = (totalMin - (totalHour * 60));
            seconds = (totalSec - (totalMin * 60));

            hours = hours < 10 ? "0" + parseInt(hours) : parseInt(hours);
            minutes = minutes < 10 ? "0" + parseInt(minutes) : parseInt(minutes);
            seconds = seconds < 10 ? "0" + parseInt(seconds) : parseInt(seconds);

            if (totalSec >= 0) {
                const daysStr = totalDays > 0 ? totalDays+dayLetter+" " : "";
                setTimeLeft(daysStr + hours + " : " + minutes + " : " + seconds);

                setIsOneHourLeft(seconds > 0 && totalMin < 60);
            }else {
                setTimeLeft(_getTimeOutLabel())
                clearInterval(theTimer.current)
            }
        }, 200);

    }

    const _getTimeOutLabel = () => {
        return (typeof(timeOutLabel) == "function" ? timeOutLabel() : timeOutLabel) || "";
    }

    const renderTimeLeft = () => {
        if(!timeLeft)
            return null;

        let label = "";
        if(propFinish)
            label = _getTimeOutLabel();
        else
            label = timeLeft || "";

        return (<div>{label}</div>);
    }

    return (<div className={`NextTournamentTimer ${isOneHourLeft ? 'oneHourLeft' : ''}`}>
        {renderTimeLeft()}
    </div>)
}

TournamentTimer.propTypes = {
    timeOutLabel: PropTypes.any,
    targetDate: PropTypes.any,
    finish: PropTypes.string
}

export default TournamentTimer;